import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { ConfigFile,  GlobalParams, ConnectedUser, eAppContext, Localization, LoginDate, eLogMode} from '../models/global/class.global';
import { LoginData, LoginQueovalAppModel, LoginEstoreAppModel, LoginWebStoreAppModel } from '../models/login';
import { CoreService } from './core.service';
import { b64DecodeUnicode } from '../utilities/utilities.function';

@Injectable({
  providedIn: 'root'
})

export class LoginService {

  private _configFile: ConfigFile;

  private _loginAlert: string = '';
  get Alert(): string {
    return this._loginAlert;
  }
  get HasAlert(): boolean {
    return (this._loginAlert !== null && this._loginAlert !== undefined && this._loginAlert !== '');
  }


  constructor(
    private http: HttpClient,
    private indParam: CoreService
  ) { }


  //#region WebStore
  loginWebStore(model: LoginWebStoreAppModel, appUrl: string, apiUrl: string): Observable<boolean> {
    const context = model.module.includes('ONLINEMARKET') ? eAppContext.ONLINEMARKET : eAppContext.WEBSTORE;
    this.indParam.AppParams = new GlobalParams(context, appUrl, apiUrl);
    this.indParam.AppParams.loginMode = eLogMode.NONE;
    return this.loginBase(model);

    //////////return this.getFileConfig(eAppContext.WEBSTORE).pipe(mergeMap((response: boolean) => {
    //////////  return response ? this.loginBase(model) : of(false);
    //////////}), catchError((error2: Error) => {
    //////////  this.LogError(error2);
    //////////  return of(false);
    //////////}));
  }
  //#endregion

  //#region Online Market
  loginOnlineMarket(model: LoginWebStoreAppModel, appUrl: string, apiUrl: string): Observable<boolean> {

    this.indParam.AppParams = new GlobalParams(eAppContext.ONLINEMARKET, appUrl, apiUrl);
    this.indParam.AppParams.loginMode = eLogMode.NONE;
    return this.loginBase(model);

  }
  //#endregion

  //#region EStore
  loginEStore(model: LoginEstoreAppModel): Observable<boolean> {
    return this.getFileConfig(eAppContext.ESTORE).pipe(mergeMap((response: boolean) => {
      return response ? this.loginBase(model) : of(false);
    }), catchError((error2: Error) => {
      this.LogError(error2);
      return of(false);
    }));
  }
  //#endregion

  //#region Queoval
  loginAspQueoval(): Observable<boolean> {
    const globParam: string | null = localStorage.getItem('GlobParam');
    if (globParam && globParam !== '') {
      this.indParam.AppParams = JSON.parse(b64DecodeUnicode(globParam));
      return this.http.get<ConfigFile>('./assets/conf.library.json').pipe(mergeMap((conf: ConfigFile) => {
        this.indParam.AppParams.apiUrl = conf.apiUrl;
        if (this.indParam.AppParams.appUrl == '') {
          this.indParam.AppParams.appUrl = this.getAppSite();
        }
        this.indParam.LoginDate = new LoginDate();
        return of(true);
      }), catchError((error3: Error) => {
        this.LogError(error3);
        return of(false);
      }));
    }
    else {

      // FABRICE - 9/11/2023 : Code utilisé pour le mode ASPX de la connexion en utilisant les pages en ASPX et ANGULAR
      return this.getFileConfig(eAppContext.QUEOVAL).pipe(mergeMap((response1: boolean) => {
        if (!response1)
          return of(false);
        else {
          const website: string = this.getAppSite();
          this.indParam.AppParams.appUrl = website;

          return this.http.get<Array<Localization>>(`${website}param/PageApiHttp.aspx?P1=&P2=&P3=QUEOVALTOKEN2`).pipe(mergeMap((response: Array<Localization>) => {
            //const aspBase: AspData = this.AspBaseData(response, eAppContext.QUEOVAL, this.indParam.ConfigFile.apiUrl);
            const aspBase: AspData = this.AspBaseData(response, eAppContext.QUEOVAL, this._configFile.apiUrl);
            if (!aspBase.validationOK)
              return of(false);

            const model: LoginQueovalAppModel = new LoginQueovalAppModel();
            model.Action = 'OLD';
            model.asptoken = aspBase.token;
            model.appname = 'QUEOVAL';
            return this.LoginApp<LoginQueovalAppModel>(aspBase.apiAddress, model);
          }), catchError((error2: Error) => {
            this.LogError(error2);
            return of(false);
          }));
        }

      // Code pour le nouveau login mode full angular (code commenté pour la mise en prod)
      //return this.http.get<ConfigFile>('./assets/conf.library.json').pipe(mergeMap((conf: ConfigFile) => {
      //  window.document.location.href = conf.applogin;
      //  return of(true);

      }), catchError((error3: Error) => {
        this.LogError(error3);
        return of(false);
      }));
    }
    // ce code est la mode ASPX
    //else {
    //  return this.getFileConfig(eAppContext.QUEOVAL).pipe(mergeMap((response1: boolean) => {
    //    if (!response1)
    //      return of(false);
    //    else {
    //      const website: string = this.getAppSite();
    //      this.indParam.AppParams.appUrl = website;
    //      return this.http.get<Array<Localization>>(`${website}param/PageApiHttp.aspx?P1=&P2=&P3=QUEOVALTOKEN2`).pipe(mergeMap((response: Array<Localization>) => {
    //        //const aspBase: AspData = this.AspBaseData(response, eAppContext.QUEOVAL, this.indParam.ConfigFile.apiUrl);
    //        const aspBase: AspData = this.AspBaseData(response, eAppContext.QUEOVAL, this._configFile.apiUrl);
    //        if (!aspBase.validationOK)
    //          return of(false);

    //        const model: LoginQueovalAppModel = new LoginQueovalAppModel();
    //        model.Action = 'OLD';
    //        model.asptoken = aspBase.token;
    //        model.appname = 'QUEOVAL';
    //        return this.LoginApp<LoginQueovalAppModel>(aspBase.apiAddress, model);
    //      }), catchError((error2: Error) => {
    //        this.LogError(error2);
    //        return of(false);
    //      }));
    //    }
    //  }), catchError((error3: Error) => {
    //    this.LogError(error3);
    //    return of(false);
    //  }));
    //}
  }

  logoutAsp(): Observable<string> {
    this.indParam.AppParams.token = '';
    if (this.indParam.AppParams.loginMode == eLogMode.FULLANGULAR || this.indParam.AppParams.loginMode == eLogMode.MIXED) {
      localStorage.removeItem('GlobParam');
      return of(this.indParam.AppLoginSite);
    }
    return this.http.post<any>(`${this.indParam.AppParams.appUrl}param/PageApiHttp.aspx?P3=LOGOUT`, {}).pipe(mergeMap((result: any) => {
      const destination: string = result && result.dest ? result.dest : '';
      if (destination === '') {
        console.error('FAILED LOGOUT: redirect page not returned');
      }
      else {
        localStorage.removeItem('GlobParam');
      }
      return of(`${destination}?ReturnUrl=Default.aspx`);
    }));
  }
  //#endregion


  private getFileConfig(MODE: eAppContext): Observable<boolean> {
    return this.http.get<ConfigFile>('./assets/conf.library.json').pipe(mergeMap((conf: ConfigFile) => {
      //////this.indParam.ConfigFile = conf;
      this._configFile = conf;

      this.indParam.AppParams = new GlobalParams(MODE, conf.appUrl, conf.apiUrl);
      this.indParam.AppParams.loginMode = MODE === eAppContext.EXTRANET
        ? (conf.loginMode && conf.loginMode === 'FULL-ANG') ? eLogMode.FULLANGULAR : eLogMode.MIXED
        : eLogMode.NONE;
      // on affect la connexion a WS login suivant le fichier de config json
      this.indParam.AppParams.apiLogin = conf.apilogin;
      // on force la redirection pour le paramatrege dans le fichier de config json (si non renseigne il est retourné par le parametrage de dbconnect)
      this.indParam.AppParams.appLoginSite = conf.applogin;
      // pour l'authentification et acces au apiAuth
      this.indParam.AppParams.UrlAuthWS = conf.UrlAuthWS;

      return of(true);
    }), catchError((error3: Error) => {
      this.LogError(error3);
      return of(false);
    }));
  }

  private loginBase<T>(model: T): Observable<boolean> {
    return this.LoginApp<T>(this.indParam.AppParams.apiUrl, model);
  }

  private getAppSite(): string {
    const ad: string = `${window.location.protocol}//${window.location.host}/`;
    const ps: string = (document && document.location && document.location.href) ? document.location.href.replace(ad, '') : '';
    if (ps && ps !== '') {
      const ap: string[] = ps.split('/');
      if (ap.length > 0) {
        return `${ad}${ap[0]}/`;
      }
    }
    return ad;
  }

  private LogError(er: Error): void {
    console.error('AUTHENTICATION ERROR: ');
    console.error(JSON.stringify(er));
  }

  private SetAppParam(log: LoginData, apiService: string): void {
    this.indParam.AppParams.token = log.Token;
    this.indParam.AppParams.tokenApiAut = log.TokenAPIAuth;
    this.indParam.AppParams.dbname = log.ConnParams.DataBase;
    this.indParam.AppParams.culture = log.ConnParams.Culture ?? "fr-FR" ;
    this.indParam.AppParams.GMT = log.ConnParams.GMT;
    this.indParam.AppParams.Role = log.UserRole;
    this.indParam.AppParams.Translation = log.TranslationData;
    this.indParam.AppParams.ConfigKeys = log.ConfigKeys;
    this.indParam.AppParams.LoggedUser = new ConnectedUser();
    this.indParam.AppParams.LoggedUser.Ident = log.ConnParams.UserID;
    this.indParam.AppParams.LoggedUser.Conx_PER = log.ConnParams.UserName;
    this.indParam.AppParams.apiUrl = apiService;

    this.indParam.AppParams.UrlExtranetSite = log.ConnParams.UrlExtranetSite;
    this.indParam.AppParams.UrlExtranetWS = log.ConnParams.UrlExtranetWS;

    this.indParam.AppParams.UrlQuestionnaireSite = log.ConnParams.UrlQuestionnaireSite;
    this.indParam.AppParams.UrlQuestionnaireWS = log.ConnParams.UrlQuestionnaireWS;

    this.indParam.AppParams.UrlElearningSite = log.ConnParams.UrlElearningSite;
    this.indParam.AppParams.UrlElearningWS = log.ConnParams.UrlElearningWS;

    this.indParam.AppParams.UrlOnlinemarketSite = log.ConnParams.UrlOnlinemarketSite;
    this.indParam.AppParams.UrlOnlinemarketWS = log.ConnParams.UrlOnlinemarketWS;

    this.indParam.AppParams.UrlPaymentWS = log.ConnParams.UrlPaymentWS;

    this.indParam.AppParams.IsRestricted = log.ConnParams.IsRestricted;
    if (this.indParam.AppParams.context === eAppContext.ESTORE) {
      /* only for the EStore we stocked temporarely on the server-side the estore-token in the GoogleAccessToken property of the appParam */
      /* now we stock it temporarely in localStorage to add it to the EStore core service at the login subscription in the EStore app.component.ts */
      localStorage.setItem('EST-TKN', log.ConnParams.Google.AccessToken);
    }
    this.indParam.LoginDate = new LoginDate();
  }

  private AspBaseData(loc: Array<Localization>, mode: eAppContext, confApiUrl: string): AspData {
    const result: AspData = new AspData(confApiUrl);
    if (!loc || loc.length < 2) {
      console.error('AUTHENTICATION ERROR: data not returned from PageApiHttp.aspx');
      result.validationOK = false;
    }

    const error: Array<Localization> = loc.filter((r1: Localization) => r1.Key === 'error');
    if (error.length > 0 && error[0].Value !== '') {
      console.error('AUTHENTICATION ERROR: ');
      console.error(error[0].Value);
      result.validationOK = false;
    }

    const queoval: Array<Localization> = loc.filter((r1: Localization) => r1.Key === 'queoval');
    if (queoval.length === 0 || queoval[0].Value === '') {
      console.error('AUTHENTICATION ERROR: token not found');
      result.validationOK = false;
    }
    result.token = queoval[0].Value;

    if (mode === eAppContext.QUEOVAL) {
      // for the Queoval Application the PageApiHttp.aspx page return one more item array (the api url)
      // this is because the api address is set at database level for the specific queoval servers configuration
      if (loc.length < 3) {
        console.error('AUTHENTICATION ERROR: data not returned from PageApiHttp.aspx');
        result.validationOK = false;
      }
      const apiurl: Array<Localization> = loc.filter((r1: Localization) => r1.Key === 'apiurl');
      if (apiurl.length === 0 || apiurl[0].Value === '') {
        console.error('AUTHENTICATION ERROR: api url not found');
        result.validationOK = false;
      }
      result.apiAddress = apiurl[0].Value;
    }

    return result;
  }

  private LoginApp<T>(apiAddress: string, model: T): Observable<boolean> {
    return this.http.post<LoginData>(`${apiAddress}api/loginapp`, model).pipe(mergeMap((data: LoginData) => {
      if (data.HasError) {
        console.log(data.Error);
        this._loginAlert = data.Error;
        return of(false);
      }

      this._loginAlert = data.Alert;

      this.SetAppParam(data, apiAddress);
      return of(true);
    }), catchError((error1: Error) => {
      this.LogError(error1);
      return of(false);
    }));
  }
}

export class AspData {
  validationOK: boolean;
  apiAddress: string;
  token: string;
  constructor(apiUrl: string) {
    this.validationOK = true;
    this.apiAddress = apiUrl;
    this.token = '';
  }
}
